import { Challenge } from '@/types';
import { CHALLENGE_TEMPLATES } from './challengeTemplates';

// Generate daily challenges that refresh every day
export function generateDailyChallenges(): Challenge[] {
  const dailyChallenges: Challenge[] = [
    {
      id: 'daily_points_20',
      name: 'Daily Points Challenge',
      title: 'Earn 20 Points',
      description: 'Complete activities to earn 20 points today',
      imageUrl: '',
      type: 'point_target',
      goalType: 'activity',
      target: 20,
      targetValue: 20,
      progress: 0,
      reward: {
        points: 10,
        petItems: ['basic_seed'],
        title: 'Daily Achiever'
      },
      startDate: new Date(),
      endDate: new Date(Date.now() + 24 * 60 * 60 * 1000), // 24 hours from now
      createdBy: 'system',
      rewardPoints: 10,
      rules: ['Complete activities to earn points'],
      isPublic: true,
      createdAt: new Date(),
      updatedAt: new Date(),
      status: 'active' as const,
      difficulty: 'easy' as const,
      category: 'daily',
      participants: [],
      participantCount: 0,
      maxParticipants: 1,
      creatorId: 'system',
      invitations: []
    },
    {
      id: 'daily_activities_3',
      name: 'Daily Activity Challenge',
      title: 'Log 3 Activities',
      description: 'Complete 3 different activities today',
      imageUrl: '',
      type: 'activity_count',
      goalType: 'activity',
      target: 3,
      targetValue: 3,
      progress: 0,
      reward: {
        points: 15,
        petItems: ['feather_toy'],
        title: 'Activity Master'
      },
      startDate: new Date(),
      endDate: new Date(Date.now() + 24 * 60 * 60 * 1000), // 24 hours from now
      createdBy: 'system',
      rewardPoints: 15,
      rules: ['Log 3 different activities'],
      isPublic: true,
      createdAt: new Date(),
      updatedAt: new Date(),
      status: 'active' as const,
      difficulty: 'medium' as const,
      category: 'daily',
      participants: [],
      participantCount: 0,
      maxParticipants: 1,
      creatorId: 'system',
      invitations: []
    }
  ];

  return dailyChallenges;
}

// Weekly challenges that refresh every week  
export function generateWeeklyChallenges(): Challenge[] {
  const weeklyChallenges: Challenge[] = [
    {
      id: 'weekly_points_100',
      name: 'Weekly Points Challenge',
      title: 'Earn 100 Points',
      description: 'Complete activities to earn 100 points this week',
      imageUrl: '',
      type: 'point_target',
      goalType: 'activity',
      target: 100,
      targetValue: 100,
      progress: 0,
      reward: {
        points: 50,
        petItems: ['premium_berry', 'puzzle_game'],
        title: 'Weekly Champion'
      },
      startDate: new Date(),
      endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 7 days from now
      createdBy: 'system',
      rewardPoints: 50,
      rules: ['Complete activities to earn points'],
      isPublic: true,
      createdAt: new Date(),
      updatedAt: new Date(),
      status: 'active' as const,
      difficulty: 'medium' as const,
      category: 'weekly',
      participants: [],
      participantCount: 0,
      maxParticipants: 1,
      creatorId: 'system',
      invitations: []
    }
  ];

  return weeklyChallenges;
}

// Community challenges that users can join
export function generateCommunityBasedChallenges(): Challenge[] {
  // For now, return empty array since challenge templates don't have required properties
  return [];
}